import app from 'flarum/forum/app';
// OJO CON ESTA RUTA. `Component` vive en `flarum/common/Component`, NO en
// `flarum/common/components/Component` (donde estan Button, Link, Page…). Con la ruta mala el
// import resuelve a `undefined`, y como webpack transpila `class X extends Y` a un `_inherits`
// que hace `Object.create(Y.prototype)`, el sintoma no es «modulo no encontrado» sino un
// `TypeError: Cannot read properties of undefined (reading 'prototype')` en tiempo de
// ejecucion, que revienta el render de TODA la pagina — incluso para anonimos, porque el fallo
// ocurre al evaluar el modulo, no al montar el componente. Costo una corrida roja de la suite.
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';

/**
 * Aviso «confirma tu correo» + reenvio, en un solo sitio (T12 · objetivo 2).
 *
 * POR QUE ESTE COMPONENTE EXISTE. Desde T11 (decision D) el alta es publica y no pasa por
 * doorkey, asi que la cuenta nace con `is_email_confirmed = 0`. Y `flarum/core`
 * (`src/User/User.php`) es explicito: sin activar, el usuario «no es mas que un invitado» — no
 * entra al grupo Miembro y por tanto no tiene `startDiscussion`. El correo dejo de ser un
 * tramite y paso a ser EL INTERRUPTOR que convierte una cuenta en participante.
 *
 * Con el interruptor en manos del correo, un enlace que no llega deja a la persona dentro del
 * foro y sin poder escribir, sin explicacion. Este aviso es la contramedida: dice por que no
 * puede publicar, a que direccion se envio, y le da la unica accion util — reenviar.
 *
 * NO HAY CODIGO NI PIN. La confirmacion de Flarum 1.8 es por ENLACE y en dos pasos
 * (`GET /confirm/{token}` pinta una pagina con un boton, `POST /confirm/{token}` confirma de
 * verdad), a proposito: asi un escaner de correo que sigue enlaces no activa la cuenta sola.
 * Inventar un segundo mecanismo de codigo numerico esta vetado por el paquete y ademas
 * romperia esa garantia.
 *
 * EL 429 NO ES UN FALLO, y por eso tiene su propio mensaje. El core limita el reenvio
 * (`send-confirmation`); recibir 429 significa que el envio anterior SI se hizo hace poco.
 * Tratarlo como error mandaria a la gente a reintentar contra un muro en vez de a mirar la
 * bandeja de entrada. Ya se documento en el runbook §21.5, midiendolo contra produccion.
 */
export default class ConfirmEmailNotice extends Component {
  /** 'idle' | 'sending' | 'sent' | 'throttled' | 'error' */
  state: string = 'idle';

  view() {
    const t = (key: string, params?: any) => app.translator.trans('umbral-comunidad.forum.confirm.' + key, params);
    const user = app.session.user;

    // Sin sesion no hay a quien reenviar: el aviso se pinta igual (el alta acaba de ocurrir y
    // el usuario todavia no tiene sesion en esta pestana) pero sin boton, que solo enganaria.
    const email = user ? user.email() : (this.attrs as any).email;

    return (
      <div className="CmConfirm" data-cm-confirm={this.state}>
        <span className="CmConfirm-ic" aria-hidden="true">
          ✉
        </span>
        <div className="CmConfirm-main">
          {/*
            EL NIVEL DEL ENCABEZADO LO ELIGE QUIEN USA EL COMPONENTE.

            En `/proponer-encuentro` este aviso ES la pantalla, asi que su titulo tiene que ser
            el `<h1>` de la pagina: los otros tres estados de M6 (`guest`, `unavailable`,
            `done`) lo son, y dejar este en `<h2>` dejaria la ruta sin encabezado de nivel 1 —
            un lector de pantalla que navegue por encabezados no encontraria el titulo.

            En el exito del alta, en cambio, el `<h1>` ya lo tiene «Cuenta creada, {name}» y
            este aviso cuelga de el, asi que ahi va como `<h2>`.
          */}
          {(this.attrs as any).heading === 'h1' ? (
            <h1 className="CmConfirm-title">{(this.attrs as any).title || t('title')}</h1>
          ) : (
            <h2 className="CmConfirm-title">{(this.attrs as any).title || t('title')}</h2>
          )}
          {/*
            Cuerpo propio de la pantalla, si lo trae, MAS la linea del correo.

            No es o lo uno o lo otro: `/proponer-encuentro` necesita decir que es lo que queda
            bloqueado («podras publicar tu propuesta»), y en las dos pantallas hace falta saber
            A QUE DIRECCION se mando — es el dato con el que la persona va a buscar en su
            bandeja, y sin el no puede ni detectar que se equivoco al escribirla.
          */}
          <p className="CmConfirm-body">
            {(this.attrs as any).body || (email ? t('body_with_email', { email }) : t('body'))}
          </p>
          {(this.attrs as any).body && email ? <p className="CmConfirm-body">{t('sent_to', { email })}</p> : null}

          {/* El estado vive DEBAJO del boton y no lo reemplaza: si el boton desapareciera al
              enviar, quien no ve llegar el correo se queda sin la unica accion disponible. */}
          {user ? (
            <div className="CmConfirm-actions">
              <Button
                className="Button CmConfirm-resend"
                data-cm-resend={this.state}
                disabled={this.state === 'sending'}
                onclick={() => this.resend(user)}
              >
                {this.state === 'sending' ? t('resend_sending') : t('resend')}
              </Button>
              {this.state !== 'idle' && this.state !== 'sending' ? (
                <p className="CmConfirm-status" data-cm-status={this.state}>
                  {t('status_' + this.state)}
                </p>
              ) : null}
            </div>
          ) : null}

          <p className="CmConfirm-hint">{t('hint_spam')}</p>
        </div>
      </div>
    );
  }

  resend(user: any) {
    this.state = 'sending';
    m.redraw();

    app
      .request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/users/' + user.id() + '/send-confirmation',
        // El 429 del limitador es una respuesta ESPERADA de este flujo, no una incidencia: sin
        // esto, `app.request` lo trataria como error y sacaria el alert generico del core
        // encima del mensaje propio, que es justo el que explica que ya se envio.
        errorHandler: (e: any) => {
          this.state = e && e.status === 429 ? 'throttled' : 'error';
          m.redraw();
        },
      })
      .then(
        () => {
          this.state = 'sent';
          m.redraw();
        },
        // EL RECHAZO HAY QUE ABSORBERLO AQUI, y no basta con `errorHandler`.
        //
        // `Application.requestErrorCatch` del core llama al `errorHandler` y DESPUES hace
        // `return Promise.reject(error)`. O sea que el handler pinta el estado correctamente
        // pero la promesa sigue rechazada; sin este segundo argumento queda una
        // `unhandledrejection` en cada fallo — y aqui el fallo COMUN es el 429 del limitador,
        // que es el camino normal de este boton, no un caso raro.
        //
        // Va como segundo argumento de `.then()` y no como un `.catch()` encadenado a
        // proposito: un `.catch()` detras del `then` de exito tambien atraparia un error
        // lanzado DENTRO de ese `then`, y lo pintaria como si hubiera fallado el envio.
        () => {
          // El estado ya lo dejo puesto `errorHandler`; aqui solo se cierra la promesa.
        }
      );
  }
}
